// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__38qFl","upload":"Small_upload__p28W6","imageWrap":"Small_imageWrap__29bZa","removeBtn":"Small_removeBtn__JeVwx"};